import { memo } from 'react';
import Facets from './Facets';
import { useErrorContext } from '../../context/ErrorContext';

export const LeftNavFacets = memo(() => {
  const { hasFacetsError = false } = useErrorContext();

  if (hasFacetsError) return null;

  return <Facets />;
});

LeftNavFacets.displayName = 'LeftNavFacets';
